export default __webpack_public_path__ + "static/media/MightyMagnets_10.758abc15.png";